import SmallCards from "./SmallCards";

export default function HowItWorks() {

    return (
        <div className="max-w-[924px] mx-auto text-center flex flex-col gap-[59px]">
            <h3 className="font-medium text-[40px]">How It Works</h3>
            <SmallCards />
        </div>
    )
}